export const volumes = [
  {
    numeral: 'I',
    color: '#22C7F0',
    title: 'The Low Back Pain Initial Assessment Framework',
    intro: ['Learn how to organize the initial interview and gather relevant information before proceeding with your physical examination.'],
    items: [
      'A structured approach to the presenting complaint.',
      'Questions about symptom onset, duration, and progression.',
      'Factors that aggravate or ease symptoms.',
      'Functional limitations and patient-reported concerns.',
      'Relevant medical history and contextual information.',
      'How to organize subjective findings.',
      'A framework for documenting the initial assessment.',
    ],
    note: '',
    goal: 'Build a consistent structure for gathering and organizing information before deciding what requires further investigation.',
  },
  {
    numeral: 'II',
    color: '#EF4444',
    title: 'The Lumbar Red Flags & Referral Guide',
    intro: [
      'Recognizing potentially concerning findings is an essential part of responsible assessment.',
      'This volume focuses on organizing relevant warning signs and understanding when further medical evaluation may be necessary.',
    ],
    items: [
      'Important historical findings and symptom patterns.',
      'Potential warning signs associated with serious underlying conditions.',
      'Considerations involving progressive neurological symptoms.',
      'Relevant bowel and bladder symptoms.',
      'Findings that may warrant urgent medical evaluation.',
      'General principles for documenting concerns and considering referral.',
      'The limitations of individual screening findings.',
    ],
    note: "The material should be interpreted alongside current clinical guidelines, local referral procedures, and the patient's complete presentation.",
    goal: 'Develop a more systematic approach to screening and recognizing when routine physiotherapy assessment may not be sufficient.',
  },
  {
    numeral: 'III',
    color: '#22C55E',
    title: 'The Lumbar Spine Physical Examination Atlas',
    intro: ['Organize the physical examination using a practical reference covering movement, function, neurological considerations, and relevant examination procedures.'],
    items: [
      'Observation and functional assessment.',
      'Lumbar movement and mobility considerations.',
      'Relevant neurological examination components.',
      'Lower-extremity symptoms and examination considerations.',
      'Strength, sensation, reflexes, and other relevant findings.',
      'Considerations for selecting physical examination procedures.',
      'Documentation of positive, negative, and inconclusive findings.',
      'Limitations of individual examination tests.',
    ],
    note: '',
    goal: "Help you organize the physical examination and interpret findings in the context of the patient's overall presentation.",
  },
  {
    numeral: 'IV',
    color: '#A855F7',
    title: 'Clinical Reasoning for Low Back Pain Presentations',
    intro: [
      'Collecting information is only one part of the assessment. You also need to understand how different findings relate to one another.',
      'This volume focuses on organizing your clinical reasoning.',
    ],
    items: [
      'How to synthesize subjective and objective findings.',
      'How to formulate and revise working hypotheses.',
      'How to consider alternative explanations.',
      'How to identify missing information.',
      'How to interpret findings in the context of the complete presentation.',
      'How to document clinical uncertainty.',
      'How to recognize when additional assessment may be necessary.',
    ],
    note: '',
    goal: 'Develop a more coherent approach to clinical reasoning instead of relying on a single symptom or examination result.',
  },
  {
    numeral: 'V',
    color: '#F59E0B',
    title: 'Differential Assessment & Clinical Decision Frameworks',
    intro: [
      'Low back pain can involve different presentations, overlapping symptoms, and varying levels of clinical complexity.',
      'This volume helps you organize your understanding of common presentations while recognizing the limitations of assessment findings.',
    ],
    items: [
      'Educational frameworks for organizing common low back pain presentations.',
      'Considerations involving referred and radiating leg symptoms.',
      'Relevant neurological findings.',
      'Factors that may suggest the need for further medical investigation.',
      'How to organize competing clinical hypotheses.',
      'Considerations for additional assessment and referral.',
      'Documentation frameworks for clinical decisions.',
      'The role of professional scope and clinical guidelines.',
    ],
    note: '',
    goal: 'Organize the information available to you and identify appropriate next steps while respecting the limits of physiotherapy assessment.',
  },
  {
    numeral: 'VI',
    color: '#38BDF8',
    title: 'The Low Back Pain Clinical Casebook',
    intro: [
      'Practice applying the assessment framework through educational case scenarios.',
      'Each case is designed to help you review how information is gathered, organized, and interpreted.',
    ],
    items: [
      'Hypothetical patient presentations.',
      'Examples of subjective histories.',
      'Selected physical examination findings.',
      'Cases involving different symptom patterns.',
      'Questions to guide clinical interpretation.',
      'Opportunities to identify missing information.',
      'Example reasoning pathways.',
      'Questions about potential warning signs and referral considerations.',
      'Reflection exercises to identify gaps in your reasoning.',
    ],
    note: 'All cases are educational scenarios, not individualized patient assessments or definitive diagnostic protocols.',
    goal: 'Practice organizing clinical information before applying your knowledge in professional settings.',
  },
];
